import { render, staticRenderFns } from "./received-order-stock-reserve-list.vue?vue&type=template&id=a210d134&"
import script from "./received-order-stock-reserve-list.vue?vue&type=script&lang=js&"
export * from "./received-order-stock-reserve-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports